var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_706_201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_706_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_706_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0227 33.2396C27.3219 33.2396 33.2392 27.3224 33.2392 20.0231C33.2392 12.7239 27.3219 6.80664 20.0227 6.80664C12.7234 6.80664 6.80615 12.7239 6.80615 20.0231C6.80615 27.3224 12.7234 33.2396 20.0227 33.2396Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0224 34.3202C27.9189 34.3202 34.3202 27.9189 34.3202 20.0224C34.3202 12.126 27.9189 5.72461 20.0224 5.72461C12.126 5.72461 5.72461 12.126 5.72461 20.0224C5.72461 27.9189 12.126 34.3202 20.0224 34.3202Z",
    stroke: "white",
    strokeWidth: 2.1627,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.2906 18.9688H18.7549C18.3056 18.9688 17.9414 19.333 17.9414 19.7823V27.3237C17.9414 27.773 18.3056 28.1372 18.7549 28.1372H21.2906C21.7399 28.1372 22.1041 27.773 22.1041 27.3237V19.7823C22.1041 19.333 21.7399 18.9688 21.2906 18.9688Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0228 17.0768C21.1723 17.0768 22.1041 16.1449 22.1041 14.9954C22.1041 13.8459 21.1723 12.9141 20.0228 12.9141C18.8733 12.9141 17.9414 13.8459 17.9414 14.9954C17.9414 16.1449 18.8733 17.0768 20.0228 17.0768Z",
    fill: "#F6F6F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_706_201",
    x: -0.162914,
    y: -0.163402,
    width: 40.3703,
    height: 40.3717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.40299
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_706_201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_706_201",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSelected);
export default __webpack_public_path__ + "static/media/info-selected.04111f2a107c449da2b788f499b1e870.svg";
export { ForwardRef as ReactComponent };